import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import redisCacheAdminService from '../services/redisCacheAdminService';

export const useRedisCacheCheck = (productId: string, retailer: string, enabled = false) => {
  return useQuery({
    queryKey: ['redisCache', 'check', productId, retailer],
    queryFn: () => redisCacheAdminService.checkProduct(productId, retailer),
    enabled: enabled && !!productId && !!retailer,
    retry: false,
  });
};

export const useRedisCacheStats = () => {
  return useQuery({
    queryKey: ['redisCache', 'stats'],
    queryFn: () => redisCacheAdminService.getStats(),
  });
};

export const useRedisCacheMutations = () => {
  const queryClient = useQueryClient();

  const flushProduct = useMutation({
    mutationFn: ({ productId, retailer }: { productId: string; retailer: string }) =>
      redisCacheAdminService.flushProduct(productId, retailer),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['redisCache'] });
      console.log('Product flushed from Redis successfully');
    },
    onError: (error: any) => {
      console.error('Failed to flush product:', error?.response?.data?.message || error.message);
    },
  });

  const flushAllProducts = useMutation({
    mutationFn: () => redisCacheAdminService.flushAllProducts(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['redisCache'] });
      console.log('All products flushed from Redis successfully');
    },
    onError: (error: any) => {
      console.error('Failed to flush all products:', error?.response?.data?.message || error.message);
    },
  });

  return { flushProduct, flushAllProducts };
};

